import { WebappApplicationFragment } from '@gql'
import { closestTo, isValid } from 'date-fns'

export function getLatestVisitDate(
  visits: WebappApplicationFragment['buyer_member']['visits']
) {
  // TODO MAKE IT WORK
  const visitDates = visits.map((slot) => new Date(slot.createdAt))

  const closestDate = closestTo(new Date(), visitDates)

  const latestVisit = visits.find(
    (visit) => new Date(visit.createdAt).getTime() === closestDate?.getTime()
  )?.startTime

  if (latestVisit == null) return null
  const latestVisitDate = new Date(latestVisit)
  if (!isValid(latestVisitDate)) return null
  return latestVisitDate
}
